export const getFranchiseMenuList = (t) => [
  {
    menuKey: "franchise-overview",
    title: t("franchiseNavOverview"),
    to: "franchise-restaurants",
    iconStyle: <i className="fas fa-sitemap" />,
  },
  {
    menuKey: "franchise-profile",
    title: t("franchiseNavProfile"),
    to: "franchise-profile",
    iconStyle: <i className="fas fa-user" />,
  },
];

export const getMenuList = (t) => [
  {
    menuKey: "restaurant",
    title: t("navGroupRestaurant"),
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-store" />,
    content: [
      {
        menuKey: "home",
        title: t("navHome"),
        to: "dashboard",
      },
      {
        menuKey: "restaurant-info",
        title: t("navRestaurantInfo"),
        to: "app-profile",
        search: "?tab=restaurant",
      },
      {
        menuKey: "restaurant-users",
        title: t("navRestaurantUsers"),
        to: "restaurant-users",
      },
      {
        menuKey: "qrcode",
        title: t("qrCode"),
        to: "app-qrcode",
      },
    ],
  },
  {
    menuKey: "plans",
    title: t("navPlans"),
    to: "plans",
    iconStyle: <i className="fas fa-credit-card" />,
  },
  {
    menuKey: "kitchen",
    title: t("navGroupKitchen"),
    to: "menu",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-utensils" />,
    content: [
      { menuKey: "kitchen-categories", title: t("categories"), to: "categories" },
      {
        menuKey: "kitchen-subcategories",
        title: t("subcategories"),
        to: "subcategoriesList",
      },
      { menuKey: "kitchen-products", title: t("products"), to: "products" },
      { menuKey: "kitchen-choices", title: t("choices"), to: "choices" },
      { menuKey: "kitchen-items", title: t("items"), to: "items" },
    ],
  },
  {
    menuKey: "pos",
    title: t("navPointOfSale"),
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-cash-register" />,
    content: [
      { menuKey: "pos-orders", title: t("orders"), to: "orders" },
      { menuKey: "pos-orders-board", title: t("ordersBoard"), to: "orders-board" },
      {
        menuKey: "pos-reservations",
        title: t("reservations"),
        to: "reservations",
      },
    ],
  },
  {
    menuKey: "clients",
    title: t("navGroupGuests"),
    to: "clients",
    iconStyle: <i className="fas fa-user-friends" />,
  },
  {
    menuKey: "events",
    title: t("navEvents"),
    to: "events",
    iconStyle: <i className="fas fa-bullhorn" />,
  },
  {
    menuKey: "support",
    title: t("navCustomerSupport"),
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-headset" />,
    content: [
      {
        menuKey: "support-my-requests",
        title: t("myRequests"),
        to: "my-support-requests",
      },
      {
        menuKey: "support-claims",
        title: t("claims"),
        to: "client-reclamations",
      },
      {
        menuKey: "support-lost-found",
        title: t("lostFound"),
        to: "lost-found",
      },
    ],
  },
  {
    menuKey: "admin-history",
    title: t("navAdminHistory"),
    to: "admin-history",
    iconStyle: <i className="fas fa-history" />,
  },
  {
    menuKey: "archives",
    title: t("Archived"),
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-archive" />,
    content: [
      { menuKey: "arch-menu", title: t("menu"), to: "menu-history" },
      {
        menuKey: "arch-categories",
        title: t("categories"),
        to: "categories-history",
      },
      {
        menuKey: "arch-subcategories",
        title: t("subcategories"),
        to: "subcategoriesList-history",
      },
      {
        menuKey: "arch-products",
        title: t("products"),
        to: "products-history",
      },
      { menuKey: "arch-items", title: t("items"), to: "items-history" },
      { menuKey: "arch-choices", title: t("choices"), to: "choices-history" },
      {
        menuKey: "arch-dashboard",
        title: t("dashboardArchives"),
        to: "dashboard-archives",
      },
      {
        menuKey: "arch-events",
        title: t("navArchivedEvents"),
        to: "archived-events",
      },
      {
        menuKey: "arch-event-reservations",
        title: t("navArchivedEventReservations"),
        to: "archived-event-reservations",
      },
      {
        menuKey: "arch-table-reservations",
        title: t("navArchivedReservations"),
        to: "archived-table-reservations",
      },
      {
        menuKey: "arch-support-requests",
        title: t("navArchivedSupportRequests"),
        to: "archived-support-requests",
      },
      {
        menuKey: "arch-claims",
        title: t("navArchivedClaims"),
        to: "archived-client-reclamations",
      },
      {
        menuKey: "arch-lost-found",
        title: t("navArchivedLostFound"),
        to: "archived-lost-found",
      },
      {
        menuKey: "arch-clients",
        title: t("navArchivedClients"),
        to: "archived-clients",
      },
      {
        menuKey: "arch-plan-floor-setups",
        title: t("navArchivedPlanFloorSetups"),
        to: "archived-plan-floor-setups",
      },
      {
        menuKey: "arch-admin-history",
        title: t("navArchivedAdminHistory"),
        to: "archived-admin-history",
      },
    ],
  },
];
